import { Component, OnInit } from '@angular/core';
import { Graph, GraphData, LocalService } from '../../../service/local.service';
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";
import { LocalDatePipe } from 'src/app/pipes/local-date.pipe';

@Component({
  selector: 'app-dummy-graph',
  templateUrl: './dummy-graph.component.html',
  styleUrls: ['./dummy-graph.component.scss']
})
export class DummyGraphComponent implements OnInit {
  data: any; graph: Graph; graphData: GraphData[];
  title = 'ng2-charts-demo';

  lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Sales',
        tension: 0.2,
        borderColor: '#787878',
        backgroundColor: '#787878'
      }
    ]
  };
  lineChartOptions: ChartOptions<'line'> = {
    responsive: true
  };
  lineChartLegend = true;

  // options: LineChartOptions = {
  //   height: 230,
  //   margin: { top: 20, right: 40, bottom: 80, left: 60 },
  //   yScale: { min: 0, max: 0 },
  //   xGrid: {
  //     opacity: 1,
  //     textColor: '#787878',
  //     color: '#787878',
  //     tickNumber: 5
  //   },
  //   yGrid: {
  //     tickPadding: 1,
  //     tickTextAnchor: 'end',
  //     tickNumber: 5,
  //     opacity: 1,
  //     textColor: '#787878',
  //     color: '#787878'
  //   },
  //   transitions: true,
  //   transitionDuration: 400,
  //   legend: false,
  //   legendPosition: 'bottom',
  //   legendMargin: { top: 0, right: 0, left: 0, bottom: 0 },
  //   initialTransition: false,
  //   interaction: {
  //     axisLine: true,
  //     axisLineSize: 4,
  //     axisLineColor: '#787878',
  //     tooltip: true,
  //     enable: false
  //   }
  // };

  // items: LineChartData[] = [
  //   new LineChartData({
  //     id: 'N/A',
  //     data: null,
  //     area: true,
  //     areaOpacity: .2,
  //     curve: 'cardinal',
  //     markers: true,
  //     lineSize: 2,
  //     color: '#787878',
  //     areaColor: '#787878',
  //     markerColor: '#787878'
  //   })
  // ];

  dataGraph = [];
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    let dateNow = this.localService.getDeviceDate();
    let graphData: GraphData[] = [];
    graphData.push({ date: this.addDays(dateNow, -6), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, -5), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, -4), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, -3), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, -2), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, -1), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    graphData.push({ date: this.addDays(dateNow, 0), y: parseInt(this.localService.getRandomString(5, true)) } as GraphData);
    this.dataGraph = this.generateDateValues(graphData);   
    this.lineChartData.labels = this.dataGraph.map(x => x['x']);
    this.lineChartData.datasets[0].data = this.dataGraph.map(x => x['y']);
    //this.items[0].id = "Sales";
    //this.items[0].data = this.dataGraph;
    //this.options.yScale.max = 100000;
  }

  generateDateValues(results: GraphData[]): { x: string; y: number }[] {
    const localDatePipe = new LocalDatePipe();
    let itms = results.map((result, i) => ({ x: localDatePipe.getMonthName((new Date(result.date)).getMonth()), y: result.y }));
    return itms;
  }

  addDays(date: Date, days: number): Date {
    date = new Date(date.setDate(days));
    return date;
  }
}
